export default "__VITE_ASSET__BjEv8eQ6__"